module.exports = __webpack_public_path__ + "img/14.de10e6ab.svg";